/* eslint-disable import/prefer-default-export */

/*  Define features that can be configurable for New Tables */
export enum DataGridSupportedFeatures {
    ShowArchived = 'showArchived',
    BulkCreate = 'bulkCreate', // not supported yet
    BulkEdit = 'bulkEdit', // not supported yet
}
